export default "__VITE_ASSET__CJzty1Ce__"